export default class NewPasswordLink {
	constructor(container) {
		const button = container.querySelector('button');
		button.onclick = function() {
			fetch(button.dataset.url).then(
				response => {
					response.text().then(
						text => {
							const textarea = container.querySelector('textarea');
							textarea.value = text;
							textarea.classList.remove('hidden');
							button.onclick = null;
						}
					);
				}
			);
		};
	}
}
